var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { lazyLoad } from '@react-page/editor';
import React from 'react';
import SlateEditor from './components/SlateEditor';
import SlateProvider from './components/SlateProvider';
import { defaultTranslations } from './default/settings';
import { HtmlToSlate } from './htmlToSlate';
import v002 from './migrations/v002';
import v003 from './migrations/v003';
import v004 from './migrations/v004';
import * as pluginFactories from './pluginFactories/index';
import defaultPlugins from './plugins/index';
import makeSlatePluginsFromDef from './utils/makeSlatePluginsFromDef';
import transformInitialSlateState from './utils/transformInitialSlateState';
var slatePlugins = defaultPlugins;
export { defaultPlugins, slatePlugins, pluginFactories, HtmlToSlate, };
var Subject = lazyLoad(function () { return import('@material-ui/icons/Subject'); });
var Controls = lazyLoad(function () { return import('./components/Controls'); });
var migrations = [v002, v003, v004];
export var DEFAULT_SLATE_PLUGIN_ID = 'ory/editor/core/content/slate';
var defaultConfig = {
    icon: React.createElement(Subject, null),
    plugins: defaultPlugins,
    defaultPluginType: 'PARAGRAPH/PARAGRAPH',
    id: DEFAULT_SLATE_PLUGIN_ID,
    version: 1,
    translations: defaultTranslations,
    migrations: migrations,
    allowInlineNeighbours: true,
};
function plugin(customize) {
    var settings = (customize
        ? customize(defaultConfig)
        : defaultConfig);
    var createData = function (customizer) {
        return transformInitialSlateState(customizer({ plugins: settings.plugins }));
    };
    var createInitialData = function () {
        return createData(function (_a) {
            var plugins = _a.plugins;
            return ({
                children: [
                    {
                        plugin: plugins.paragraphs.paragraph,
                        children: [''],
                    },
                ],
            });
        });
    };
    // plugins should be flatten
    // NEW: to make it easier to manage and group plugins,
    // they now need to be an object of object with group and keys, see type SlatePluginCollection
    var plugins = makeSlatePluginsFromDef(settings.plugins);
    var htmlToSlate = HtmlToSlate({ plugins: plugins });
    return {
        Provider: function (props) { return (React.createElement(SlateProvider, __assign({}, props, { plugins: plugins, translations: settings.translations, defaultPluginType: settings.defaultPluginType }))); },
        Renderer: function (props) { return (React.createElement(SlateEditor, __assign({}, props, { plugins: plugins, translations: settings.translations, defaultPluginType: settings.defaultPluginType }))); },
        bottomToolbar: {
            dark: true,
        },
        controls: {
            type: 'custom',
            Component: function (props) { return (React.createElement(Controls, __assign({}, props, { plugins: plugins, translations: settings.translations }))); },
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        id: settings.id || settings.name,
        version: settings.version,
        icon: settings.icon,
        title: settings.title || settings.translations.pluginName,
        description: settings.description || settings.translations.pluginDescription,
        hideInMenu: settings.hideInMenu,
        allowInlineNeighbours: settings.allowInlineNeighbours,
        allowClickInside: true,
        // disable default hotkeys
        handleRemoveHotKey: function () { return Promise.reject(); },
        handleFocusPreviousHotKey: function () { return Promise.reject(); },
        handleFocusNextHotKey: function (e, node) { return Promise.reject(); },
        createInitialData: createInitialData,
        createInitialState: createInitialData,
        createInitialSlateState: createData,
        createData: createData,
        createDataFromHtml: htmlToSlate,
        // remove selection
        serialize: function (_a) {
            if (_a === void 0) { _a = { slate: [] }; }
            var slate = _a.slate, selection = _a.selection, rest = __rest(_a, ["slate", "selection"]);
            return (__assign({ slate: slate }, rest));
        },
        unserialize: function (s) {
            var _a;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ((_a = s) === null || _a === void 0 ? void 0 : _a.importFromHtml) {
                // this is no longer supported, but we do not delete it
                return __assign(__assign({ 
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    importFromHtml: s.importFromHtml }, s), createInitialData());
            }
            if (s === null || s === void 0 ? void 0 : s.slate) {
                return __assign(__assign({}, s), { selection: null });
            }
            return createInitialData();
        },
        migrations: settings.migrations,
    };
}
export default plugin;
//# sourceMappingURL=index.js.map